import { writeContractAndWait } from "../viem";
import config from "../../config/config";
import MafiaOCJoinAbi from "../../abis/MafiaOCJoin.json";
import { toWei } from "../../utils/utils";

const address = config.ocJoinAddress;
const abi = MafiaOCJoinAbi;

export const createLobby = async (
  cashAmount: number,
  assetExpectation: number,
  minRank: number,
  message: string,
  signature: string,
  account: string
) => {
  const cashAmountWei = toWei(cashAmount);

  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "createLobby",
    args: [
      cashAmountWei,
      assetExpectation,
      minRank,
      JSON.stringify(message),
      signature,
    ],
    account,
  });
  return tx;
};

export const joinAsDriver = async (
  lobbyId: number,
  carId: number,
  message: string,
  signature: string,
  account: string
) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "joinAsDriver",
    args: [lobbyId, carId, JSON.stringify(message), signature],
    account,
  });
  return tx;
};

export const joinAsWeaponExpert = async (
  lobbyId: number,
  weaponId: number,
  bulletAmount: number,
  message: string,
  signature: string,
  account: string
) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "joinAsWeaponExpert",
    args: [
      lobbyId,
      weaponId,
      toWei(bulletAmount),
      JSON.stringify(message),
      signature,
    ],
    account,
  });
  return tx;
};

export const joinAsExplosiveExpert = async (
  lobbyId: number,
  grenadeIds: number[],
  molotovIds: number[],
  armorId: number,
  message: string,
  signature: string,
  account: string
) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "joinAsExplosiveExpert",
    args: [
      lobbyId,
      grenadeIds,
      molotovIds,
      armorId,
      JSON.stringify(message),
      signature,
    ],
    account,
  });
  return tx;
};

export const joinAsTeamExpert = async (
  lobbyId: number,
  bodyguardId: number,
  message: string,
  signature: string,
  account: string
) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "joinAsTeamExpert",
    args: [lobbyId, bodyguardId, JSON.stringify(message), signature],
    account,
  });
  return tx;
};

export const kickMember = async (
  lobbyId: number,
  memberIndex: number,
  account: string
) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "kickMember",
    args: [lobbyId, memberIndex],
    account,
  });
  return tx;
};

export const leaveLobby = async (lobbyId: number, account: string) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "leaveLobby",
    args: [lobbyId],
    account,
  });
  return tx;
};

export const cancelLobby = async (lobbyId: number, account: string) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "cancelLobby",
    args: [lobbyId],
    account,
  });
  return tx;
};
